<template>
  <div class="container">
    <content-header :data="[{text:'小程序首页分类推荐', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="targetId"
            label="分类ID">
          </el-table-column>
          <el-table-column
            prop="title"
            label="显示名称">
          </el-table-column>
          <el-table-column
            prop="sequence"
            label="显示顺序">
          </el-table-column>
          <el-table-column
            prop="dateUpdated"
            label="发布日期">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改分类' : '添加分类'" width="50%" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm">
            <el-form-item prop="targetId" label="分类" :label-width="formLabelWidth">
              <el-cascader
                expand-trigger="hover"
                :options="categoryOpts"
                :props="defaultProp"
                :show-all-levels="false"
                v-model="curObj.targetValue"
                change-on-select
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="title" label="显示名称" :label-width="formLabelWidth">
              <el-input v-model="curObj.title" auto-complete="off"></el-input>
              <el-tooltip class="item" effect="dark" content="用于小程序端显示，可不修改" placement="bottom">
                <i class="iconfont icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item prop="sequence" label="显示顺序" :label-width="formLabelWidth">
              <el-input v-model.number="curObj.sequence" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>

          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { mapState } from 'vuex'
  import MarketingModel from 'models/marketing'
  import CategoryModel from 'models/category'

  export default {
    data () {
      return {
        tableData: [],
        curObj: {
          id: '',
          targetId: '',
          targetValue: [],
          title: '',
          sequence: 3
        },
        curObjRules: {
          targetValue: [{ required: true, message: '请选择分类', trigger: 'blur' }],
          title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          sequence: [{ required: true, message: '请输入显示顺序', trigger: 'blur' },
            { type: 'number', message: '显示顺序必须为数值' }]
        },
        isObjShow: false,
        formLabelWidth: '80px',
        categoryOpts: [],
        defaultProp: {
          children: 'child',
          label: 'name',
          value: 'id'
        },
      }
    },
    created () {
      MarketingModel.findClientHomeFeatured({businessType: 5}).then(res => {
        // console.log(res)
        this.tableData = res
      })
      CategoryModel.find().then(res => {
        let tmpTree = {id: '', name: '', child: res.category_tree}
        removeEmptyChild(tmpTree)

        function removeEmptyChild (node) {
          if (node != null) {
            if (node.child.length === 0) {
              delete node.child
            } else {
              let childrens = node.child
              for (let i = 0; i < childrens.length; i++) {
                removeEmptyChild(childrens[i])
              }
            }
          }
        }
        this.categoryOpts = tmpTree.child
      })
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            MarketingModel.deleteClientHomeFeatured({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          title: '',
          sequence: 3,
          targetId: '',
          targetValue: []
        }
        this.isObjShow = true
      },
      newHandle () {
        MarketingModel.createClientHomeFeatured({
          title: this.curObj.title,
          targetId: this.curObj.targetId,
          targetType: 4,
          sequence: this.curObj.sequence,
          businessType: 5
        }).then(res => {
          // console.log(res)
          MarketingModel.findClientHomeFeatured({businessType: 5}).then(res => {
            this.tableData = res
          })
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          title: item.row.title,
          targetId: item.row.targetId,
          sequence: item.row.sequence,
        }
        let targetValue = []
        for (let i = 0; i < this.categoryOpts.length; i++) {
          if (findTargetValue(this.categoryOpts[i], this.curObj.targetId, targetValue)) {
            break
          }
        }
        this.curObj.targetValue = targetValue

        console.log(this.curObj)

        function findTargetValue (node, id, targetValue) {
          if (node != null) {
            // console.log(targetValue)
            // console.log(node.id)
            targetValue.push(node.id)
            if (node.id === id) {
              // console.log('found======')
              return true
            } else {
              if (node.hasOwnProperty('child')) {
                for (let i = 0; i < node.child.length; i++) {
                  let found = findTargetValue(node.child[i], id, targetValue)
                  if (found) {
                    return true
                  }
                }
                targetValue.pop()
                return false
              } else {
                targetValue.pop()
                return false
              }
            }
          }
        }
        this.isObjShow = true
      },
      editHandle () {
        MarketingModel.updateClientHomeFeatured({
          id: this.curObj.id,
          title: this.curObj.title,
          targetId: this.curObj.targetId,
          targetType: 4,
          sequence: this.curObj.sequence,
          businessType: 5
        }).then(res => {
          MarketingModel.findClientHomeFeatured({businessType: 5}).then(res => {
            this.tableData = res
          })
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      //
      handleChange (value) {
        console.log(value)
        this.curObj.targetId = value[value.length - 1]
        let tmpTree = {id: '', name: '', child: this.categoryOpts}
        this.curObj.title = findNodeName(tmpTree, this.curObj.targetId)

        function findNodeName (node, id) {
          if (node != null) {
            if (node.id === id) {
              return node.name
            } else {
              if (node.hasOwnProperty('child')) {
                for (let i = 0; i < node.child.length; i++) {
                  let name = findNodeName(node.child[i], id)
                  if (name !== '') {
                    return name
                  }
                }
                return ''
              } else {
                return ''
              }
            }
          } else {
            return ''
          }
        }
        // console.log(this.curObj)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
</style>



// WEBPACK FOOTER //
// src/views/HomeCategory.vue